/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Component, OnInit, Input, Injectable, Self } from '@angular/core';
import { Router } from '@angular/router';
import {
    IcecontrolSettings,
    IcemattableSettings,
    IcepanelgroupSettings,
    IcepanelsectionSettings,
    IcepanelSettings,
    IcepanelcontainerRowSettings,
    IcepanelcontainerSettings
} from '../../../../icemedx-lib/src/components/models/icesettings';
import { IcepanelService } from '../../../../icemedx-lib/src/components/icepanel/icepanel.service';
import { IcepanelContainerComponent } from '../../../../icemedx-lib/src/components/icepanel/icepanelcontainer.component';
import { IcepanelComponent } from '../../../../icemedx-lib/src/components/icepanel/icepanel.component';
import { IcecontrolComponent } from '../../../../icemedx-lib/src/components/icepanel/icecontrol.component';
import { IcematgridComponent } from '../../../../icemedx-lib/src/components/icepanel/icematgrid.component';
import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';
import { PatientKioskService } from '../../../../icemedx-lib/src/services/patientkiosk/patientkiosk.service'
import { patient } from '../../../../icemedx-lib/src/models/domain/patient';
import { patientindex } from '../../../../icemedx-lib/src/models/domain/patientindex';
import { variable } from '@angular/compiler/src/output/output_ast';
import { FormGroup, FormArray, FormBuilder, Validators, ReactiveFormsModule, FormsModule  } from '@angular/forms';
import { AppService } from '../app.service';

@Component({
    selector: 'nameofpatient',
    templateUrl: './nameofpatient.component.html',
    styleUrls: ['./nameofpatient.component.scss'],
    providers: [IcepanelService]
})

@Injectable()
export class NameofpatientComponent implements OnInit {
    public nameOfPatientInfoForm: FormGroup;
    title = 'app';
    @Input() patient = null;

    patientIndex: patientindex;
    firstName: string = "";
    lastName: string = "";
    dateOfBirth;
    phone: string = "";


    @Input() verifyPatient: Function = (settings) => {
        this.router.navigate([this.appsvc.getBaseRoutePath('verification')]);
    };

    @Input() onPatientSearch: Function = (settings) => {
        if (!isNaN(this.dateOfBirth)) {
            var dob = Iceutility.getDateTextEx(dob);
            var data = this.patientKioskService.searchPatient(this.dateOfBirth).subscribe(data => {
                sessionStorage.setItem("patientDetails", JSON.stringify(this.patientIndex));
                this.router.navigate([this.appsvc.getBaseRoutePath('fullprofile')]);
            });
            //  this.router.navigate(['/verification']);
        }
    };

    @Input() onFirstnameChange: Function = (settings) => {
        if (settings !== null) {
            this.patientIndex.first_name = settings.target.value;
        }
    };

    @Input() onLastnameChange: Function = (settings) => {
        if (settings !== null) {
            this.patientIndex.last_name = settings.target.value;
        }
    };

    @Input() onDateofBirthChanges: Function = (settings) => {
        if (settings !== null) {
            this.dateOfBirth = new Date(settings.properties.currEvent.value);
            this.patientIndex.dob = this.dateOfBirth;
        }
    };

    @Input() onPhoneChange: Function = (settings) => {
        if (settings !== null) {
            this.patientIndex.communication_number1 = settings.target.value;
        }
    };


    inboxSettings: IcepanelcontainerSettings = null;

    constructor(private router: Router, private patientKioskService: PatientKioskService, private appsvc: AppService, public fb: FormBuilder) { }

    ngOnInit() {

        this.nameOfPatientInfoForm = this.fb.group({
            FirstName:"Ravikumar"
          });

        var patientDetails = JSON.parse(sessionStorage.getItem("patientDetails"));
        if (patientDetails !== null) {
            this.patientIndex = patientDetails;
        } else {
            this.patientIndex = new patientindex();
        }

        this.patient = new patient();
        let panelTag = "NameofPatient";
        let panelKey = Iceutility.guid(false);

        let controls: IcecontrolSettings[] = [
            new IcecontrolSettings("iceinput", { placeholder: "First name", value: this.patientIndex.first_name }, null, { change: this.onFirstnameChange }, "FirstName"),
            new IcecontrolSettings("iceinput", { placeholder: "Last name", value: this.patientIndex.last_name }, null, { change: this.onLastnameChange }),
            new IcecontrolSettings("icedatepicker", { placeholder: "Date of birth", value: this.patientIndex.dob }, null, { dateChange: this.onDateofBirthChanges }),
            new IcecontrolSettings("iceinput", { placeholder: "Phone", value: this.patientIndex.communication_number1 }, null, { change: this.onPhoneChange }),
            new IcecontrolSettings("icebutton", { text: "Continue", class: ["btn-danger"], glyphClass: "fa-plus-circle" }, null, { onClick: this.onPatientSearch })
        ];

        let sections: IcepanelsectionSettings[] = [
            new IcepanelsectionSettings(
                "InboxSection",
                {
                    class: ["yalla"],
                    styles: {
                        width: "100%"
                    }
                },
                null,
                controls,
                null)
        ];
        let panels: IcepanelSettings[] = [
            new IcepanelSettings(panelTag, panelKey, "Patient Kiosk - Name of patient", "", sections)];

        let panelrows: IcepanelcontainerRowSettings[] = [new IcepanelcontainerRowSettings(panels)];
        this.inboxSettings = new IcepanelcontainerSettings("MessageInbox", panelrows);
    }
}

